import { Node, mergeAttributes } from '@tiptap/core';

const AiField = Node.create({
  name: 'aiField',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  addAttributes: () => ({
    outputKey: { default: null, rendered: false },
    fieldKey: { default: null, rendered: false },
    instanceId: { default: null, rendered: false },
    fallbackValue: { default: null, rendered: false },
    label: { default: null, rendered: false },
    required: { default: false, rendered: false },
    renderedValue: { default: null, rendered: false },
    candidates: { default: [], rendered: false },
    selectedCandidateIndex: { default: null, rendered: false },
    selectedValue: { default: null, rendered: false },
  }),
  parseHTML: () => [{
    tag: 'span[data-ai-field]',
    getAttrs: (element) => ({
      outputKey: element.getAttribute('data-ai-output') || String(element.getAttribute('data-ai-field') || '').replace(/^ai\./, ''),
      fieldKey: element.getAttribute('data-ai-field'),
      instanceId: element.getAttribute('data-ai-instance'),
      fallbackValue: element.getAttribute('data-ai-fallback'),
      label: element.getAttribute('data-ai-label'),
      required: element.getAttribute('data-ai-required') === 'true',
    }),
  }],
  renderHTML: ({ node, HTMLAttributes }) => ['span', mergeAttributes(HTMLAttributes, {
    'data-ai-field': node.attrs.fieldKey || `ai.${node.attrs.outputKey}`,
    'data-ai-output': node.attrs.outputKey || String(node.attrs.fieldKey || '').replace(/^ai\./, ''),
    'data-ai-instance': node.attrs.instanceId,
    'data-ai-fallback': node.attrs.fallbackValue,
    'data-ai-label': node.attrs.label,
    'data-ai-required': String(node.attrs.required),
    class: 'ai-field-chip',
  }), node.attrs.renderedValue || `[AI: ${node.attrs.label || node.attrs.outputKey || node.attrs.fieldKey}]`],
  renderText: ({ node }) => node.attrs.selectedValue || node.attrs.renderedValue || node.attrs.fallbackValue || `{{ai.${node.attrs.outputKey || String(node.attrs.fieldKey || '').replace(/^ai\./, '')}}}`,
  addNodeView() {
    return ({ editor, node, getPos }) => {
      const dom = document.createElement('span');
      dom.className = 'ai-field-chip';
      const update = (nextNode) => {
        if (nextNode.type.name !== this.name) return false;
        node = nextNode;
        dom.textContent = node.attrs.renderedValue || `[AI: ${node.attrs.label || node.attrs.outputKey || node.attrs.fieldKey}]`;
        dom.dataset.aiField = node.attrs.outputKey || node.attrs.fieldKey || '';
        return true;
      };
      dom.addEventListener('click', () => {
        const position = typeof getPos === 'function' ? getPos() : null;
        if (typeof position === 'number') editor.chain().setNodeSelection(position).run();
      });
      update(node);
      return { dom, update };
    };
  },
  addCommands() {
    return {
      insertAiField: (attrs) => ({ commands }) => commands.insertContent({
        type: this.name,
        attrs: { ...attrs, instanceId: attrs.instanceId || globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}` },
      }),
    };
  },
});

export default AiField;
export { AiField };
